import { isLogtoEnabled } from '@savgroup-front-common/core/services/isLogtoEnabled';

const { hostname } = window.location;
const logtoClientId = 'jqxuhesirc2et3q5atrrc';

const defaultAuthority = isLogtoEnabled()
  ? 'https://idp-dev.revers.io/oidc'
  : 'https://dev-login.revers.io';

const mapClientIdByHostname: Record<string, string> = isLogtoEnabled()
  ? {
      'dev-app-carrefour.revers.io': '629ywissnir8p88f9ewwv',
    }
  : {
      'dev-app.revers.io': 'dev-control.revers.io',
      'dev2-app.revers.io': 'dev-control.revers.io',
      localhost: 'dev-control.revers.io',
    };

const mapAuthorityByHostname: Record<string, string> = isLogtoEnabled()
  ? {
      localhost: defaultAuthority,
    }
  : {
      localhost: defaultAuthority,
    };

const mapDirectSigningByHostname: Record<string, string> = {
  'dev2-app.revers.io': 'sso:123456789',
  'dev-app-carrefour.revers.io': 'sso:xiqe0j4jy64m',
};

const AuthConfiguration = {
  authority: mapAuthorityByHostname[hostname] || defaultAuthority,
  clientId: isLogtoEnabled()
    ? mapClientIdByHostname[hostname] || logtoClientId
    : mapClientIdByHostname[hostname] || window.location.hostname,
  scope: isLogtoEnabled()
    ? 'openid email api offline_access profile'
    : 'openid email api',
  direct_sign_in: isLogtoEnabled()
    ? mapDirectSigningByHostname[hostname] || 'sso:bxkstz7hbrji'
    : undefined,
};

if (hostname.includes('.dev-control.pages.dev')) {
  AuthConfiguration.clientId = isLogtoEnabled()
    ? logtoClientId
    : 'dev-control.revers.io';
  AuthConfiguration.authority = defaultAuthority;
}

export default AuthConfiguration;
